export default __webpack_public_path__ + "static/kankitsukei2-06e1c080b839eb75c256378ac8c41d54.jpg";